<template>
    <div :class="['paragraphDivisionLine', themeText()]"></div>
</template>

<script>
'use strict';
import {  getTheme } from '@/utils/index';
export default {
  methods:{
    themeText() {
      return getTheme() ? 'dark' : 'light'
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '@/style/var.styl';
.paragraphDivisionLine {
    margin-bottom: 0.32rem;
    width: 3.28rem;
    height: 0.0033rem
    opacity: 0.12;
}

.dark {
  background: #ffffff !important; 

}

.light {
    background: #000000 !important; 

}

</style>
